export default __webpack_public_path__ + "static/media/arrow_down.540d3afd.svg";